/* tslint:disable */

/**
 */
export class VehicleRoutePeriodView {
    last_total_revenue_pos?: number;
    license_plates?: string;
    now_count_shift?: number;
    now_total_count_ticket?: number;
    now_total_revenue_pos?: number;
    now_total_revenue_charge?: number;
    now_total_revenue_month?: number;
    now_total_revenue_qr_code?: number;
    last_count_shift?: number;
    last_total_count_ticket?: number;
    route_number?: number;
    last_total_revenue_charge?: number;
    last_total_revenue_month?: number;
    last_total_revenue_qr_code?: number;
    percent_count_shift?: number;
    percent_total_count_ticket?: number;
    percent_total_revenue_pos?: number;
    percent_total_revenue_charge?: number;
    percent_total_revenue_month?: number;
    percent_total_revenue_qr_code?: number;
}
